/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-card[_ngcontent-%COMP%]{margin:10px 20px}\n/*# sourceMappingURL=contacts.component.css.map*/"];
export { styles as styles };
